import axios from "axios";
import { common } from "../../utils";
import { API_URL } from "../../utils/api-utils";

export const GetListViewHistory = async (param) => {
  let url = `${API_URL.Loader}/api/ExtendOutbound/GetListViewHistory`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const GetListExtendTime = async (param) => {
  let url = `${API_URL.Loader}/api/ExtendOutbound/GetListExtendTime`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const UpdateExtendTime = async (param) => {
  let url = `${API_URL.Loader}/api/ExtendOutbound/ExtendTime`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};


